import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { copilotEndpoints } from '@/modules/copilot/constants';
import type { ApiRequestBody } from '@/types/utils/request';

type SendCopilotMessageBody = ApiRequestBody<
  typeof copilotEndpoints.copilot,
  'post'
>;

export const useSendCopilotMessageMutation = () => {
  return useMutation({
    mutationFn: async (body: SendCopilotMessageBody) => {
      const { data } = await fetchClient.POST(copilotEndpoints.copilot, {
        body,
      });
      return data;
    },
  });
};
